import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Modal, Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import extract from '../../core/extract'
import {relFilter} from '../../core/links'
import LoaderButton from '../../core/components/LoaderButton'
import Icon from '../../core/components/Icon'
import ButtonToggle from '../../core/components/ButtonToggle'
import {REFERENCE_COMPANY_CMD_TYPES, BILLING_TYPES, ReferenceCompanyCmd} from '../models'
import {REFERENCE_COMPANY_CMD_UPDATED, updateReferenceCompanyCmd, sendReferenceCompanyCmd, loadCompanyStream} from '../actions'
import i18n from '../i18n'
import CompanySelectInput from './CompanySelectInput'
import style from './ReferenceCompanyModal.less'

function restrict(allowed, value) {
    if (value) return allowed.indexOf(value) >= 0 && value || allowed[0]
    return allowed[0]
}

class ReferenceCompanyModal extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {dispatch, cmd, _links} = this.props
        
        const commandTypes = REFERENCE_COMPANY_CMD_TYPES.filter(relFilter(_links))
        this.setState({commandTypes})

        dispatch(updateReferenceCompanyCmd({
            commandType: restrict(commandTypes, cmd && cmd.commandType),
            holdingReference: null
        }))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps._links != this.props._links) {
            const {dispatch, cmd, _links} = nextProps

            const commandTypes = REFERENCE_COMPANY_CMD_TYPES.filter(relFilter(_links))
            this.setState({commandTypes})

            dispatch(updateReferenceCompanyCmd({
                commandType: restrict(commandTypes, cmd && cmd.commandType),
                holdingReference: null
            }))
        }
    }

    _sendCmd() {
        const {dispatch, onHide} = this.props

        return dispatch(sendReferenceCompanyCmd()).then(() => {
            return dispatch(loadCompanyStream())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, cmd, _links, onHide, ...others} = this.props
        const {commandTypes} = this.state

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const commandTypeField = (field) => {
            function onChange(value) {
                if (value) {
                    field.onChange(value)
                }
            }

            return {...field, onChange}
        }

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.newCompany}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={style.companyCmdType}>
                        <Row>
                            <Col xsHidden sm={3}>
                                <h5>type</h5>
                            </Col>
                            <Col sm={9}>
                                <ButtonToggle
                                    {...commandTypeField(form.commandType())}>
                                    <ul className={style.container}>
                                        {commandTypes.map((cmdType, index) => (
                                            <li
                                                key={index}>
                                                <Button
                                                    bsStyle='link'
                                                    value={cmdType}>
                                                    <Icon
                                                        icon={cmdType.slice(6)}
                                                        size='md' />
                                                    <span>{extract(i18n.referenceCompanyCmdTypeEnum, cmdType)}</span>
                                                </Button>
                                            </li>
                                        ))}
                                    </ul>
                                </ButtonToggle>
                            </Col>
                        </Row>
                    </div>
                    <form className='form-horizontal'>
                        {form.billingType && (
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='select'
                                name='billingType'
                                label={requiredLabel(i18n.billingType)}
                                {...form.billingType()}>
                                {BILLING_TYPES.map((billingType, index) => (
                                    <option
                                        key={index}
                                        value={billingType}>
                                        {extract(i18n.billingTypeEnum, billingType)}
                                    </option>
                                ))}
                            </Input>
                        )}
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='name'
                            label={requiredLabel(i18n.label)}
                            {...form.label()} />
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='siret'
                            label={form.siretNumber.isRequired() && requiredLabel(i18n.siret) || i18n.siret}
                            {...form.siretNumber()} />
                            {form.callCenterReference && (
                                <CompanySelectInput
                                    companyType='CallCenter'
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    name='callCenter'
                                    label={requiredLabel(i18n.callCenter)}
                                    {...form.callCenterReference()} />
                            )}
                    </form>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

ReferenceCompanyModal = connectForm({
    target: 'cmd',
    schema: ReferenceCompanyCmd.selectSchema,
    action: REFERENCE_COMPANY_CMD_UPDATED
})(ReferenceCompanyModal)

ReferenceCompanyModal = connect((state) => ({
    cmd: state.company.referenceCompanyCmd,
    _links: state.company._links
}))(ReferenceCompanyModal)

export default ReferenceCompanyModal


// WEBPACK FOOTER //
// ./lib/company/components/ReferenceCompanyModal.js